<template>
  <div id="app" :class="{'simple-view': isSimpleView}">
      <ModalDealAlerts v-if="showModalDealAlerts" />  
      <HomepageVideo v-if="showHomePageVideo" />
      <Navigation />
      <SearchSuggestions />
      
      <div :class="{'hide-search-results': $globalStore.isFocusedOnInput}">
        <router-view :key="$route.fullPath" />
        <div class="top-gray-box margin-top bottom-gray-box" v-if="showSocialLinks">
            <SocialLinks />
        </div>
        <div class="copyright-container">
            <span class="copyright">2025 &copy; All Rights Reserved. <span v-if="settings.siteName == 'mommydeals' || settings.siteName == 'petpetdeals' || settings.siteName == 'chaideals'">{{settings.siteNameCaps}} is a subsidiary of Zigitech Solutions Inc</span></span>
            <span><a href="/privacy-policy">Privacy Policy</a></span>
            <span style="padding: 10px; font-size: 10pt;">Disclosure: {{settings.siteNameCaps}} is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for us to earn advertising fees by advertising and linking to Amazon.com. As An Amazon Associate we earn from qualifying purchases. Product prices and availability are accurate as of the date/time indicated and are subject to change without notice including promo codes.</span>
        </div>
        <newsletter-modal />
      </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import Navigation from '@/components/Nav.vue'
import SocialLinks from '@/components/SocialLinks.vue'
import HomepageVideo from '@/components/HomePageVideo.vue'
import SearchSuggestions from '@/components/SearchSuggestions.vue'
import settings from '@/settings'
import EventBus from '@/helpers/event-bus'
import clicky from '@/helpers/clicky'
import { globalStore } from '@/stores/globalStore'
import ModalDealAlerts from '@/modals/ModalDealAlerts.vue'

const route = useRoute()
const isSimpleView = ref(false)
const showHomePageVideo = ref(false)
const showSocialLinks = ref(true)
const $globalStore = globalStore()

const showModalDealAlerts = computed(() => $globalStore.showModalDealAlerts)


onMounted(() => {
  isSimpleView.value = !!route.query.direct

  if (route.name === 'dealshare' || route.name === 'analysis' || route.name === 'analytics' || route.name === 'aitrain') {
    showSocialLinks.value = false
  }

  EventBus.on('playHomepageVideo', () => {
    console.log('playHomepageVideo')
    clicky.log('Open Homepage Video', 'click')
    showHomePageVideo.value = true
  })

  EventBus.on('stopHomepageVideo', () => {
    console.log('stopHomepageVideo')
    showHomePageVideo.value = false
  })
})
</script>


<style>


@media all and (max-width: 980px) {
  .hide-search-results {
    display: none;
  }
}

</style>

